module.exports = __webpack_public_path__ + "media/images/revenue_share_gantt-ec412573a45ed163da7211b11f483050.png";